
export const defaultSelectedDateFrom = () => {
    let d = new Date();
    return `${d.getFullYear()}01`;
};
export const defaultSelectedDateUp = () => {
    let d = new Date();
    let month  = d.getMonth()+1;
    month  =  month<10 ? '0'+month.toString() : month.toString();
    return `${d.getFullYear()}${month}`;
};


export default {
    loading: {
        module: false
    },
    params: {
        year_month_from: defaultSelectedDateFrom(),
        year_month_up: defaultSelectedDateUp(),
        account_id: null,
        contact_id: null,
        type_contact: 'Cliente'
    },

    params_contact :{
        is_customer :1,
        is_provider :0,
        is_employee :0,
    },
    reporte_contacts:[],
    contacts:[],
    accounts:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/balance-for-contacts/state.js